<template>
  <v-ons-page :class="classObject">
    <v-ons-tabbar :swipeable="md()" position="auto" :tabs="tabs" :index.sync="tabIndex">
    </v-ons-tabbar>
    <div class="toast" :class="md() ? 'toast--material' : ''" id="update-found">
      <div class="toast__message" :class="md() ? 'toast--material__message' : ''">
        更新があります。<br>再読込してください。
      </div>
      <button class="toast__button">
        <v-ons-icon size="30px" icon="md-refresh" @click="reload"></v-ons-icon>
      </button>
      <button class="toast__button">
        <v-ons-icon size="30px" icon="md-close" @click="close"></v-ons-icon>
      </button>
    </div>
  </v-ons-page>
</template>

<script>
  import TutorialTab from './components/TutorialTab'
  import CalcTab from './components/CalcTab'
  import MusicListTab from './components/MusicListTab'
  import SettingsTab from './components/SettingsTab'
  import anime from 'animejs'

  export default {
    name: 'app',
    data () {
      return {
        classObject: {
          ios: !this.md(),
          android: this.md()
        },
        tabIndex: 0,
        tabs: [
          {
            icon: 'md-help-outline',
            label: 'チュートリアル',
            page: TutorialTab,
            name: 'tutorial-tab'
          },
          {
            icon: 'fa-calculator',
            label: 'HS計算',
            page: CalcTab,
            name: 'calc-tab'
          },
          {
            icon: 'fa-list-ul',
            label: '楽曲リスト',
            page: MusicListTab,
            name: 'music-list-tab'
          },
          {
            icon: 'fa-cog',
            label: '設定',
            page: SettingsTab,
            name: 'settings-tab'
          }
        ]
      }
    },
    methods: {
      md () {
        return this.$ons.platform.isAndroid()
      },
      reload () {
        location.reload()
      },
      close () {
        anime({
          targets: '#update-found',
          opacity: '0',
          duration: 300,
          easing: 'easeInOutCubic',
          complete: function () {
            document.querySelector('#update-found').style.display = 'none'
          }
        })
      }
    },
    created: function () {
      let settings = JSON.parse(localStorage.getItem('settings'))
      if (settings) {
        let tab = this.tabs.find(e => e.label === settings.initial_tab)
        this.tabIndex = this.tabs.indexOf(tab)
      }
    },
    mounted: function () {
      document.addEventListener('updateInstalled', e => {
        document.querySelector('#update-found').style.display = 'flex'
        anime({
          targets: '#update-found',
          opacity: '1',
          duration: 300,
          easing: 'easeInOutCubic'
        })
      })

      let thisComponent = this

      document.addEventListener('applyBpm', e => {
        thisComponent.tabIndex = 1
      })

      document.querySelectorAll('ons-tab').forEach(elem => {
        elem.addEventListener('mousedown', e => {
          if (elem.className.includes('active')) {
            let event = new CustomEvent('clearPageStack', {detail: this.tabs[this.tabIndex].name})
            document.dispatchEvent(event)
          }
        })
      })
    }
  }

  /* ピンチインピンチアウトによる拡大縮小を禁止 */
  document.documentElement.addEventListener('touchstart', function (e) {
    if (e.touches.length >= 2) {
      e.preventDefault()
    }
  }, false)
  /* ダブルタップによる拡大を禁止 */
  let t = 0
  document.documentElement.addEventListener('touchend', function (e) {
    let now = new Date().getTime()
    if ((now - t) < 350) {
      e.preventDefault()
    }
    t = now
  }, false)
</script>
<style>
  body, input, textarea, select {
    /* 入力欄にフォーカスが当たっても拡大しない */
    font-size: 17px;
  }

  .hidden {
    display: none;
  }

  #update-found {
    display: none;
    opacity: 0;
  }

  .ios #update-found {
    margin-bottom: 55px;
  }

  #update-found .toast--material__message {
    padding-top: 10px;
    padding-bottom: 8px;
  }
</style>





// WEBPACK FOOTER //
// src/App.vue